module.exports = __webpack_public_path__ + "static/media/football-live-score.5473bf9e.jpg";